import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  friendLeaderboard: [],
  everyoneLeaderboard: [],
  friendLeaderboardWaiting: false,
  everyoneLeaderboardWaiting: false,
});

const reducer = function leaderboardReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_FRIEND_LEADERBOARD:
      return state.set('friendLeaderboard', action.friendLeaderboard);
    case t.SET_EVERYONE_LEADERBOARD:
      return state.set('everyoneLeaderboard', action.everyoneLeaderboard);
    case t.LOAD_EVERYONE_LEADERBOARD_WAITING:
      return state.set('everyoneLeaderboardWaiting', action.value);
    case t.LOAD_FRIEND_LEADERBOARD_WAITING:
      return state.set('friendLeaderboardWaiting', action.value);
    default:
      return state;
  }
};

export default reducer;
